import superagent from 'superagent'

export async function getTerminals({ offset, limit }) {
    const { body } = await superagent.get('/api/terminals')
      .query({ offset, limit });
      
    return body;
  }